// Brand Ambassadors on/off per company (BA E3, principal spec 2026-11-02).
//
// Platform staff switch `brand_ambassadors` on or off for a company on the
// admin portal. Every BA entry point in the app — navigation, portfolio
// screens, the named-approver and booking-type controls — renders through
// <BaGate> / useBaEnabled() so it appears only for an entitled company.
//
// ⚠️ Presentation only: employee-service and workassignment-service enforce the
// same entitlement server-side (E1/E2). Hiding here is never the check.
//
// Unlike hasProduct(), this is STRICT: BA is a paid product every company
// starts without, so no entitlement data, a failed load or a disabled row all
// mean "hidden". Hidden means nothing at all — never an error page.
import React from 'react';
import { useEntitlements } from './useEntitlements';

export const BA_PRODUCT = 'brand_ambassadors';

export function useBaEnabled(): { loaded: boolean; enabled: boolean } {
  const { loaded, hasProductStrict } = useEntitlements();
  return { loaded, enabled: loaded && hasProductStrict(BA_PRODUCT) };
}

export const BaGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { enabled } = useBaEnabled();
  return enabled ? <>{children}</> : null;
};

export default BaGate;
